import { TFCartSummary } from '~graphql/generated/graphql'

/**
 * Function formatting the total cart price based on the cart item count.
 * If there are no cart items, 0 sum should be displayed regardless of the price of transport, discounts, etc.
 */
export const getCartSum = (cartContent: Nullable<TFCartSummary>) => {
  if (!cartContent) {
    return `0`
  }

  const cartIsEmpty = cartContent.itemCount === 0
  if (cartIsEmpty) {
    return `0 ${cartContent.totalSum.currency.code}`
  }

  return cartContent.totalSum.formattedValue
}
